import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {MetricTileSize} from './metric-tile.types';

@Component({
  selector: 'app-metric-tile',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './metric-tile.component.html',
  host: {class: 'contents'},
})
export class MetricTileComponent {
  readonly label = input.required<string>();
  readonly value = input<string | null>(null);
  readonly suffix = input('');
  readonly emptyText = input('–');
  readonly size = input<MetricTileSize>('lg');
  readonly inset = input(false);
  readonly dimWhenEmpty = input(false);
  readonly testId = input<string | null>(null);

  protected readonly empty = computed(() => !this.value());
  protected readonly displayValue = computed(() =>
    this.empty() ? this.emptyText() : `${this.value()}${this.suffix()}`,
  );
  protected readonly dimmed = computed(() => this.dimWhenEmpty() && this.empty());
  protected readonly valueClass = computed(() =>
    this.size() === 'xl' ? 'text-2xl font-bold' : 'text-xl font-bold',
  );
  protected readonly frameClass = computed(() =>
    this.inset() ? 'bg-second-level rounded-lg p-3' : 'card p-4',
  );
}
